import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const POST_REQUEST_VERIFY_EMAIL = 'EMPLOYEE/POST_REQUEST_VERIFY_EMAIL'

const apiCall = enhancedMakeFetchAction(POST_REQUEST_VERIFY_EMAIL, payload => ({
  endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/users/send-email-verification-code`,
  method: 'POST',
  body: payload,
  notify: true,
  isStay: true
}))

export default apiCall
